import { Module } from 'vuex';
import api from '../../api/modules/reports';
import * as types from '../mutation-types';
import { pick } from 'lodash';

interface State {
  userActivity: UserActivityResponse | null;
  userActivityStats: UserActivityStatsResponse[] | null;
  userSales: ReportsSalesResponse | null;
  userSalesStats: ReportsSalesStatsResponse | null;
}

const initialState: State = {
  userActivity: null,
  userActivityStats: null,
  userSales: null,
  userSalesStats: null,
};

const reportModule: Module<State, any> = {
  namespaced: true,
  state: initialState,
  actions: {
    async getUserActivity({ commit }, params): Promise<void> {
      const { page, year } = pick(params, ['page', 'year']);
      const result = await api.getUserActivity(page, year);
      commit(types.SET_USER_ACTIVITY, result);
    },
    async getUserActivityStats({ commit }, year: number): Promise<void> {
      const result = await api.getUserActivityStats(year);
      commit(types.SET_USER_ACTIVITY_STATS, result);
    },
    async getUserSales({ commit }, params): Promise<void> {
      const { page, year } = pick(params, ['page', 'year']);
      const result = await api.getUserSales(page, year);
      commit(types.SET_REPORTS_SALES, result);
    },
    async getUserSalesStats({ commit }, year: number): Promise<void> {
      const result = await api.getUserSalesStats(year);
      commit(types.SET_REPORTS_SALES_STATS, result);
    },
    async getMetabaseReport(
      _,
      { reportId, params }
    ): Promise<MetabaseReportReponse> {
      return await api.getMetabaseReport(reportId, params);
    },
    async getMetabaseReports(_): Promise<MetabaseReportReponse[]> {
      return await api.getMetabaseReports();
    },
    async getMetabaseProductReports(_): Promise<MetabaseReportReponse[]> {
      return await api.getMetabaseProductReports();
    },
  },
  mutations: {
    [types.SET_USER_ACTIVITY](state: State, data: UserActivityResponse) {
      state.userActivity = data;
    },
    [types.SET_USER_ACTIVITY_STATS](
      state: State,
      data: UserActivityStatsResponse[]
    ) {
      state.userActivityStats = data;
    },
    [types.SET_REPORTS_SALES](state: State, data: ReportsSalesResponse) {
      state.userSales = data;
    },
    [types.SET_REPORTS_SALES_STATS](
      state: State,
      data: ReportsSalesStatsResponse
    ) {
      state.userSalesStats = data;
    },
  },
};
export default reportModule;
